import { GearSearchQueryRequest } from '../../Model/GearSearchQueryRequest';

export const searchKeys = {
  all: ['search'] as const,
  filteredSearch: (searchQuery?: GearSearchQueryRequest) => [...searchKeys.all, { searchQuery }] as const
};
